:host {
  display: block;
  min-width: 320px;
}
